import script from "./ReadingStreakWidgetFull16464.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadingStreakWidgetFull16464.vue?vue&type=script&setup=true&lang=ts"

import "./ReadingStreakWidgetFull16464.vue?vue&type=style&index=0&id=8540ed16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8540ed16"]])

export default __exports__